export default __webpack_public_path__ + "7a0e1a17fa4bd0c612b88b4d22d3247a.png";